enum NotificationConcern {
    General = 0
}

export default NotificationConcern;
